export default __webpack_public_path__ + "static/feature5-1176c1d52ee1cfed10a57b5157a80f53.webp";